/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import { connect } from 'react-redux';
// nodejs library that concatenates classes
import classnames from "classnames";
// reactstrap components
import { Row, Col } from "reactstrap";
import { FormGroup, Input } from "reactstrap";
import {setLogo,setSelectedContactUser,setSelectedContactAddress,setSelectedContactInfo,setSelectedCompany, setValidDate, setQuoteLabel, setClientOrderNumber, setQuoteClientLabel, setDeliveryRequired, setCompanyUpdated, setContactUpdated, setCompanyLoaded, setCompany, setQuoteLoading} from '../../actions/quote'
import ReactDatetime from "react-datetime";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import CompanyForm from "./CompanyForm"
import ContactQuoteForm from "./ContactQuoteForm"
import DeliveryForm from "./DeliveryForm";
import {Collapse} from 'react-collapse';
import {covertDate} from "../../common"
import Moment from 'react-moment';
import { Tooltip } from 'reactstrap';
import Memo from "./Memo"
import { Editor } from '@tinymce/tinymce-react';


function Index(props) {
  const [openContactEdit, setOpenContactEdit] = useState(false);
  const [openLabelEdit, setOpenLabelEdit] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [noteModal, setNoteModal] = useState(false);
  const [newMemoNote, setNewMemoNote] = useState("");
  const [memoNote, setMemoNote] = useState("");
  const [addresses, setAddresses] = useState([]);
  const [userId, setUserId] = useState(null);
  const [openBody1, setOpenBody1] = useState(true);
  const [openBody2, setOpenBody2] = useState(true);
  const [memos, setMemos] = useState([]);

  const toggletooltip = () => setTooltipOpen(!tooltipOpen);

  
  const toggleNote = () => setNoteModal(!noteModal);
  const company = props.quote.company

  const user = localStorage.getItem('user_bigbrand');
  var role = ""
  if(user && user != undefined){
    var userinfo = JSON.parse(user)
    role = userinfo['role']
  }

  const {
    selectedContactUser,
    selectedContactAddress,
    selectedContactInfo,
    selectedCompany,
    validDate,
    quoteLabel,
    clientLabel,
    delivery_required
  } = props.quote;
  
  const {
    contactNames
  } = props;

  const addMemo =async()=>{
    var bodyFormData = new FormData();
    bodyFormData.append('memo_note', newMemoNote);

    axios.post(`/quotes/addmemo/${props.quote.id}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){           
        getmemo();
        setNoteModal(false)
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }

  const uploadfile =async(e)=>{
    var userId = props.quote.user_id
    
    if(userId) {
      var bodyFormData = new FormData();
      bodyFormData.append('user_to', userId);
      bodyFormData.append('file', e.target.files[0]); 
      bodyFormData.append('msg_type', 'quote');
      bodyFormData.append('quote_id', props.quote.id);
      if(props.quote){
        axios.post(`/quotes/uploadmemofile`, bodyFormData).then(res => {
          console.log("UPLOAD FROM: EditOrder.js");
          const result = res.data;
          if(result.status == "success"){        
            getmemo();
            // setNoteModal(false)
          }
          else{
            toast.error(result.data);
          }
        }).catch(err => {
          toast.error('Something was wrong. Try again');
        })
      }
      else{
        toast.error('Quote is empty');
      }
    }
  }

  const updateCompany=(company)=>{
    var bodyFormData = new FormData();
    if(company.logo){
      delete company.logo
    }
    bodyFormData.append('company', JSON.stringify(company));
    if(!company){
      toast.error('Form is empty');
      return;
    }
    
    if(!company.company || company.company == ""){
      toast.error('Company Name is required');
      return;
    }

    if(company && company.id){
      props.setCompanyUpdated(false)
      props.setQuoteLoading(true)
      axios.post(`/companies/edit/${company.id}`, bodyFormData).then(res => {
        const result = res.data;
        props.setQuoteLoading(false)
        if(result.status == "success"){        
          toast.success("Your company has been updated"); 
          props.setCompany(res.data.data)
          props.setCompanyUpdated(true)
        }
        else{
          toast.error(result.data);
        }
      }).catch(err => {
        toast.error('Something was wrong. Try again');
        props.setQuoteLoading(false)
      })
    }
    else{
      props.setCompanyUpdated(false)
      props.setQuoteLoading(true)
      axios.post(`/companies/add/${userId}`, bodyFormData).then(res => {
        const result = res.data;
        props.setQuoteLoading(false)
        if(result.status == "success"){        
          toast.success("Your company has been added"); 
          props.setCompany(res.data.data)
          props.setCompanyUpdated(true)
        }
        else{
          toast.error(result.data);
        }
      }).catch(err => {
        toast.error('Something was wrong. Try again');
        props.setQuoteLoading(false)
      })
    }
  } 


  const updateContact=(contact)=>{
    if(!company || (company && !company.id)){
      toast.error('Create the company first');
      return false;
    }
    var bodyFormData = new FormData();
    contact.company_id = company.id
    bodyFormData.append('contact', JSON.stringify(contact));
    if(contact.id){
      props.setContactUpdated(false)
      props.setQuoteLoading(true)
      axios.post(`/companies/editcontact/${contact.id}`, bodyFormData).then(res => {
        const result = res.data;
        props.setQuoteLoading(false)
        if(result.status == "success"){        
          toast.success("Your contact has been updated"); 
          props.setCompany(res.data.data)
          props.setContactUpdated(true)
        }
        else{
          toast.error(result.data);
        }
      }).catch(err => {
        toast.error('Something was wrong. Try again');
        props.setQuoteLoading(false)
      })
    }
    else{
      props.setContactUpdated(false)
      props.setQuoteLoading(true)
      axios.post(`/companies/addcontact`, bodyFormData).then(res => {
        const result = res.data;
        props.setQuoteLoading(false)
        if(result.status == "success"){        
          toast.success("Your contact has been added"); 
          props.setCompany(res.data.data)
          props.setContactUpdated(true)
          props.setSelectedContactUser(null)
        }
        else{
          toast.error(result.data);
        }
      }).catch(err => {
        toast.error('Something was wrong. Try again');
        props.setQuoteLoading(false)
      })
    }
  } 

  useEffect(() => { 
    if(props.quote.id || (props.quote.id && (props.quote.contact_updated || props.quote.company_updated))){
      if(props.quote.memo_note)
        setMemoNote(props.quote.memo_note)
      else{
        setMemoNote(null)
      }
      setUserId(props.quote.user_id)
      axios.get(`/companies/getcompanybyuser/${props.quote.user_id}`).then(res => {
        props.setCompanyLoaded(true);
        console.log('res.data',res.data)
        if(res.data.status == "success"){
          var company = res.data.data
          if(company){
            props.setCompany(company)
          }
        }
      }) 

      getmemo()

    }
  },[props.quote.id, props.quote.contact_updated , props.quote.company_updated]);
  
  const getmemo = ()=>{
    axios.get(`/quotes/getmemo/${props.quote.id}`).then(res => {
      if(res.data.status == "success"){
        setMemos(res.data.data)
      }
    }) 
  }

  const removememo = (id)=>{
    axios.get(`/quotes/removememo/${id}`).then(res => {
      if(res.data.status == "success"){
        getmemo()
      }
    }) 
  }
  
  const toggleOpenContactEdit = () => {
    setOpenContactEdit(!openContactEdit);
  }
  const toggleOpenLabelEdit = () => {
    setOpenLabelEdit(!openLabelEdit);
  }
  const onChangeContact=(value)=>{
    props.setSelectedContactUser(value)
    var found = false;
    for(var index in contactNames){
      var contact  = contactNames[index];
      if(contact['id'] == value){
        if(contact){
          var address = 
          (contact['fullname']?contact['fullname']:"")+"\n\n"+(contact['address']?contact['address']:"")+"\n"+(contact['suburb']?contact['suburb']:"")+", "+(contact['state']?contact['state']:"")+", "+(contact['postcode']?contact['postcode']:"");
          props.setSelectedContactAddress(address);
          var company = 
          (contact['company']?contact['company']:"")+"\n"+(contact['phone']?contact['phone']:"")+"\n"+(contact['email']?contact['email']:"");
          props.setSelectedContactInfo(company);
          found = true; break;
        }
      }
    }
    if(!found){
      props.setSelectedContactAddress("");
      props.setSelectedContactInfo("");
    }
  }


  const renderDate = (props, openCalendar, closeCalendar)=> {
    function clear() {
      props.onChange({ target: { value: "" } });
    }
    return (
      <div className="d-flex">        
        <label className="mb-0" style={{width:60}}><b>Valid To</b> </label>
        <div className="field" style={{width:'calc(100% - 60px)'}}>
          <span style={{fontSize:'0.875rem'}} className="pl-2 pr-2">{validDate}</span>
          { role=="admin"&&<i style={{float:'right', marginTop:5}} onClick={openCalendar} className="fa fa-calendar cursor-pointer ml-2 mr-2"/>}
        </div>
      </div>
    );
  }
  

  var today = new Date();
  // var date = (today.getMonth()+1)+'/'+today.getDate()+'/'+today.getFullYear();
  var date = '';
  // console.log("props.quote.created_at", props.quote.created_at)
  if(props.quote.created_at){
    date = (props.quote.created_at)
  }  
  
  const categories = props.quote.categories;
  var decoration = "";
  for(var index in categories){
    const category = categories[index]
    var groups = category.items
    if(groups){
      for(var groupInd = 0; groupInd< groups.length; groupInd++){
        var items = groups[groupInd]
        if(items){
          for(var loop = 0; loop < items.length; loop++){
            var item = items[loop];
            if(item.type == "decoration"){
              decoration = item['code']?item['code']:"";
            }
          }
        }
      }
    }
    break;
  } 
  return (
    <>
      <Row className="">     
        <Col className="text-left" xs="9">
          <Row className="order-header-head position-relative">       
            <Col className="text-left" xs="4">
              <h6><b>Quote</b></h6>
            </Col>    
            <Col className="text-left" xs="4">  
              <h6><b>Company</b></h6>
            </Col>   
            <Col className="text-left" xs="4">
                <h6><b>Contact</b></h6>    
            </Col>   
            <div className="expand-btn" onClick={()=>setOpenBody1(!openBody1)}>  
            {
              openBody1?
              <span style={{fontSize:36}} className="material-icons ">expand_less</span> :
              <span style={{fontSize:36}} className="material-icons ">expand_more</span>
            }            
            </div>
          </Row>
        </Col>              
        <Col className="text-left" xs="3">
          <Row className="order-header-head position-relative">           
            <Col className="text-left" xs="12">
                <h6 ><b>Collection</b></h6>   
            </Col>
            <div className="expand-btn" onClick={()=>setOpenBody2(!openBody2)}>  
            {
              openBody2?
              <span style={{fontSize:36}} className="material-icons ">expand_less</span> :
              <span style={{fontSize:36}} className="material-icons ">expand_more</span>
            }            
            </div>
          </Row>
        </Col>     
      </Row>
      <Row className="order-header order-header-body">       
        <Col xs="9">
          <Collapse isOpened={openBody1}>
            <Row className="m-0">
              <Col xs="4" className="card-col">  
                <h5 className="d-flex">
                  <b className="d-flex w-100">
                    <span style={{width:70}}>#{props.quote.id?props.quote.id:"______"}</span>
                    {openLabelEdit?
                      <>
                        <Input className="input-field" value={quoteLabel} style={{maxWidth:200, display:'inline', marginLeft:10}} type="text"  onChange={(e)=>props.setQuoteLabel(e.target.value)}/>
                        { role=="admin"&&<i style={{fontSize:17, marginTop:8}} onClick={toggleOpenLabelEdit} className="fa fa-pencil mr-2"/>}
                      </>:
                      <div className="field" style={{width:'calc(100% - 110px)', marginLeft:10}}>
                        <span>&nbsp;{quoteLabel}&nbsp;</span>
                        { role=="admin"&&<i style={{fontSize:17, marginTop:7, float:'right'}} onClick={toggleOpenLabelEdit} className="fa fa-pencil mr-2"/>}
                      </div>
                    }
                    <span className="ml-1">{props.quote.revision?"R"+props.quote.revision:""}</span>
                  </b>        
                </h5>
                {/* {props.quote.order_status && */}
                <>
                  <label className="mb-0" style={{minWidth:95}}>
                    <b>Client Order Number:</b> 
                    <Input className="input-field" value={props.quote.wfm_order_no} style={{maxWidth:150, display:'inline', marginLeft:10}} type="text"  onChange={(e)=>props.setClientOrderNumber(e.target.value)}/>
                    {/* <span  className="pl-2">{props.quote.wfm_order_no}</span> */}
                  </label>
                  <br/>
                </>
                {/* } */}
                <div className="d-flex align-items-center">
                  <label className="mb-0" style={{width:90}}><b>Description: </b> </label>
                  <Input className="input-field" value={clientLabel} style={{maxWidth:200, display:'inline', marginLeft:10}} type="text"  onChange={(e)=>props.setQuoteClientLabel(e.target.value)}/>
                  <label className="help-icon" style={{margin:"0 0 0 10px"}} href="#" id={`orderheader-description`}>i</label>
                </div>
                <hr/>
                  <Tooltip placement="bottom" isOpen={tooltipOpen} className="text-left" target="orderheader-description" toggle={toggletooltip}>
                    You can add your own quote description here.<br/>
                    Or, if you have a PO#, you can enter this here.
                  </Tooltip>
                <Row className="mt-3">
                  <Col md="5">
                    <label className="mb-0" style={{minWidth:95}}><b>Date</b> 
                      <span  className="pl-2">
                          {date}
                      </span>
                    </label>
                  </Col>
                  <Col md="7">
                    <ReactDatetime
                      inputProps={{
                        placeholder: "Date Picker Here"
                      }}
                      dateFormat="DD/MM/YYYY"
                      timeFormat={false}
                      onChange={
                        date => {
                          console.log(date);
                        var date_string =  date._d.getDate() + "/" + (date._d.getMonth()+1) + "/" + date._d.getFullYear() 
                        props.setValidDate(date_string)
                        }
                      }
                      renderInput={renderDate}
                      closeOnSelect={true}
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md="12">
                    <div className="position-relative">
                      <div 
                        style={{
                          whitespace: 'pre-line',
                          width:'100%',
                          height:'180px',
                          overflowX:'hidden',
                          overflowY:'auto',
                          padding:'10px 12px',
                          border:'1px solid #d0d0d0',
                          borderRadius: 3
                        }}
                      >
                        {/* {memoNote?memoNote:""} */}
                        
                        <Memo memos = {memos} removememo = {removememo}/>
                      </div>      
                      <span style={{position:'absolute', bottom:2, right: 20, display:'flex', background:'white'}}>
                        <i style={{fontSize:18}} className="fa fa-commenting-o mr-2" aria-hidden="true"></i>  
                        { role=="admin"&& 
                        <i onClick={()=>setNoteModal(true)} style={{fontSize:19, marginTop:1}} className="fa fa-plus-square-o cursor-pointer" aria-hidden="true"></i>   
                        } 
                      </span>       
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs="4" className="card-col">     
                <CompanyForm  mode={props.mode} role={role} company={company} updateCompany={updateCompany} onChangeCompany={()=>{}}/>
              </Col>
              <Col xs="4" className="card-col">                       
                <ContactQuoteForm  mode={props.mode} company={company} updateContact={updateContact}/>
              </Col>
            </Row>          
          </Collapse> 
        </Col>                  
        <Col xs="3">
          <Collapse isOpened={openBody2}>   
            <DeliveryForm  mode={props.mode} company={company} updateContact={updateContact}/>
          </Collapse> 
        </Col>
      </Row>
      
      <Modal className="modal-lg conversation-log" isOpen={noteModal} toggle={toggleNote} size="lg">
        <ModalHeader toggle={toggleNote}>
          <h3 className="h4 font-weight-bold mb-0">
          Conversation Log
          </h3>
        </ModalHeader>
        <ModalBody>
              <FormGroup>
                <Memo memos = {memos} removememo = {removememo}/>
              </FormGroup>
              <FormGroup>
              {/* <Input type="input" rows="" value={newMemoNote} onChange={(e)=>setNewMemoNote(e.target.value)} placeholder="Type here..."/> */}
              <Editor
                initialValue={''}
                apiKey='tjdmpms7zl95nzbouj8gcxhkk9q122xd7fsce8wjk0hqwn8g'
                init={{
                  plugins: 'link image code',
                  toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code',
                  content_style: "p { margin: 0 0 3px 0; }",
                }}
                onChange={(e)=>setNewMemoNote(e.target.getContent())}
              />
              
              </FormGroup>
              <div style={{display:'flex', justifyContent:'flex-end', padding:"0 20px"}}>
                <Button className="" onClick={()=>{document.getElementById(`upload-file`).click();}}  color="primary" type="button">
                  Upload File
                </Button>
                <Button color="primary" onClick={()=>addMemo()}>Add</Button>{' '}
                <Button color="secondary" onClick={toggleNote}>Close</Button>
              </div>
              <input type="file" id={`upload-file`} style={{display:'none'}} onChange={(e)=>uploadfile(e)}/>
        </ModalBody>            
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setLogo: logoImage=>dispatch(setLogo(logoImage)),
    setSelectedContactUser: (selectedContactUser)=>dispatch(setSelectedContactUser(selectedContactUser)),
    setSelectedContactAddress: selectedContactAddress=>dispatch(setSelectedContactAddress(selectedContactAddress)),
    setSelectedContactInfo: selectedContactInfo=>dispatch(setSelectedContactInfo(selectedContactInfo)),
    setSelectedCompany: selectedCompany=>dispatch(setSelectedCompany(selectedCompany)),
    setValidDate: date=>dispatch(setValidDate(date)),
    setQuoteLabel: value=>dispatch(setQuoteLabel(value)),
    setClientOrderNumber: value=>dispatch(setClientOrderNumber(value)),
    setQuoteClientLabel: value=>dispatch(setQuoteClientLabel(value)),
    setDeliveryRequired: value=>dispatch(setDeliveryRequired(value)),
    setCompanyUpdated: value=>dispatch(setCompanyUpdated(value)),
    setContactUpdated: value=>dispatch(setContactUpdated(value)),
    setCompanyLoaded: value=>dispatch(setCompanyLoaded(value)),
    setCompany: value=>dispatch(setCompany(value)),
    setQuoteLoading: value=>dispatch(setQuoteLoading(value)),
  };
};


export default connect(mapStateToProps, mapDispatchProps)(Index);